import apiClient from '../middleware/apiClient';

import { XFI_PODS } from '../helpers/order';
import {
  DSM_DEVICES,
  DSM_RETURNS,
  COTTON_DSM_RETURNS,
  COTTON_V1_DSM_RETURNS,
} from '../helpers/apis';
import { callApiWithFallback } from '../helpers/apiFallback';
import { kibanaLog } from '../helpers/logger';

import { newReturn } from '../helpers/models';
import { RESET_RETURNS } from './returns';
import cottonFlagManager from '../helpers/featureFlags/cotton';

// Fetch Services
export const FETCH_SERVICES = 'FETCH_SERVICES';
export const FETCH_SERVICES_SUCCESS = 'FETCH_SERVICES_SUCCESS';
export const FETCH_SERVICES_FAILURE = 'FETCH_SERVICES_FAILURE';

export const SELECT_DEVICES = 'SELECT_DEVICES';
export const CHOOSE_REASONS = 'CHOOSE_REASONS';
export const CHOOSE_RETURN_METHOD = 'CHOOSE_RETURN_METHOD';

export const SUBMIT_RETURN_ORDER = 'SUBMIT_RETURN_ORDER';
export const SUBMIT_RETURN_ORDER_SUCCESS = 'SUBMIT_RETURN_ORDER_SUCCESS';
export const SUBMIT_RETURN_ORDER_FAILURE = 'SUBMIT_RETURN_ORDER_FAILURE';

export const RESET_CONFIRMATION = 'RESET_CONFIRMATION';

export const loadServices = () => async (dispatch, getState) => {
  if (getState().order.loading === false) {
    return getState().order;
  }
  const payload = apiClient.fetch(DSM_DEVICES);
  dispatch({ type: FETCH_SERVICES, payload });
  let services;
  try {
    services = await payload;
    dispatch({ type: FETCH_SERVICES_SUCCESS, payload: services });
  } catch (error) {
    dispatch({ type: FETCH_SERVICES_FAILURE, payload: error });
    throw error;
  }
  return getState().order;
};

export const selectDevices = devices => dispatch => dispatch({
  type: SELECT_DEVICES,
  payload: devices,
});

export const chooseReasons = reasons => dispatch => dispatch({
  type: CHOOSE_REASONS,
  payload: reasons,
});

const dispatchSubmitReturnOrder = ({ selectedDevices }, endpoint = DSM_RETURNS) => ({
  type: SUBMIT_RETURN_ORDER,
  payload: apiClient.fetch(endpoint, {
    method: 'post',
    body: JSON.stringify({
      devices: selectedDevices.map(({
        description,
        title,
        type,
        modelCode,
        returnReason,
        serialNumber,
      }) => ({
        description: description || title || 'Unkown',
        serialNumber,
        deviceType: type,
        modelCode,
        returnReason,
      })),
      returnMethod: 'UPS',
    }),
  }),
});

const dispatchSubmitReturnOrderSuccess = payload => ({
  type: SUBMIT_RETURN_ORDER_SUCCESS,
  payload,
});

const dispatchSubmitReturnOrderFailure = payload => ({
  type: SUBMIT_RETURN_ORDER_FAILURE,
  payload,
});

// Dispatches the return order using the appropriate API based on cotton feature flags
const submitReturnOrder = async (dispatch, orderPayload) => {
  const { isAptV1Enabled, dsmReturnsEnabled } = cottonFlagManager;
  if (isAptV1Enabled) {
    kibanaLog('apt_v1_dsm_returns_post_api_called');
    return dispatch(dispatchSubmitReturnOrder(orderPayload, COTTON_V1_DSM_RETURNS)).payload;
  }
  if (dsmReturnsEnabled) {
    return callApiWithFallback(
      dispatch,
      () => dispatchSubmitReturnOrder(orderPayload, COTTON_DSM_RETURNS),
      () => dispatchSubmitReturnOrder(orderPayload, DSM_RETURNS),
      'dsm_returns',
    );
  }
  return dispatch(dispatchSubmitReturnOrder(orderPayload, DSM_RETURNS)).payload;
};

export const chooseReturnMethod = ({ method }) => async (dispatch, getState) => {
  dispatch({ type: CHOOSE_RETURN_METHOD, payload: method });
  const { order } = getState();
  if (method === 'ups') {
    try {
      const data = await submitReturnOrder(dispatch, order);
      dispatch({ type: RESET_RETURNS });
      const payload = newReturn(data, order.selectedDevices, 'UPS');
      dispatch(dispatchSubmitReturnOrderSuccess(payload));
      return payload;
    } catch (error) {
      dispatch(dispatchSubmitReturnOrderFailure(error));
      return null;
    }
  }
  const payload = newReturn({ returnOrderId: method }, order.selectedDevices, method);
  dispatch(dispatchSubmitReturnOrderSuccess(payload));
  return payload;
};

export const submitXfiPodReturn = () => async (dispatch, getState) => {
  const { order } = getState();

  const payload = {
    ...order,
    selectedDevices: [{
      friendlyName: XFI_PODS,
      type: XFI_PODS,
      make: XFI_PODS,
      model: XFI_PODS,
      returnReason: XFI_PODS,
      serialNumber: XFI_PODS,
    }],
  };

  try {
    const response = await submitReturnOrder(dispatch, payload);
    const confirmation = newReturn(response, payload.selectedDevices, 'ups');
    dispatch(dispatchSubmitReturnOrderSuccess({ ...confirmation, initiatedXfiPodReturn: true }));
    return confirmation;
  } catch (error) {
    dispatch(dispatchSubmitReturnOrderFailure(error));
    return null;
  }
};

const dispatchResetConfirmation = () => ({
  type: RESET_CONFIRMATION,
});

export const resetConfirmation = () => (dispatch) => {
  dispatch(dispatchResetConfirmation());
};
